export default __webpack_public_path__ + "static/media/Rachel-Compressed.8b40f882.png";